export const SET_PARAMS = "SET_PARAMS";
export const DRIVING_MKT_SET_MSG = "DRIVING_MKT_SET_MSG";
export const DRIVING_MKT_CLEAR_MSG = "DRIVING_MKT_CLEAR_MSG";
